export default "__VITE_ASSET__a20583c8__"